import { render, staticRenderFns } from "./fetch.vue?vue&type=template&id=24bbc59d&scoped=true&"
import script from "./fetch.vue?vue&type=script&lang=js&"
export * from "./fetch.vue?vue&type=script&lang=js&"
import style0 from "./fetch.vue?vue&type=style&index=0&id=24bbc59d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbc59d",
  null
  
)

export default component.exports